export default __webpack_public_path__ + "static/media/aptosLogo.ed9b2f20.png";